<template>
  <nav class="sc__iconNavBar">
    <ul>
      <slot />
    </ul>
  </nav>
</template>

<script src="./index.js"></script>

<style lang="scss">
  @import './style.scss';
</style>
